import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit {

  year: number;
  semVer: string;
  buildDate: string;

  constructor() {
    const version = environment.version.split('+');
    this.semVer = version[0];
    this.buildDate = version[1] ?? '';
    this.year = new Date().getFullYear();
  }

  ngOnInit() {
  }

}
